import axios from 'axios';
import { Token } from '../interfaces/token';

async function getToken(username: string, password: string): Promise<Token> {
	try {
		const response = await axios.get<Token>('/token', {
			headers: {
				Authorization: `Basic ${btoa(`${username}:${password}`)}`,
			},
		});

		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getClientSiteToken(clientId: number, siteId: number): Promise<Token> {
	try {
		const response = await axios.get<Token>(`/token/client/${clientId}/site/${siteId}`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const tokens = {
	getToken,
	getClientSiteToken,
};
